import "../../style.css";
import { useProgress } from '@react-three/drei';
import React from "react";

export default function Loader() {
    const { progress } = useProgress();
    const roundedProgress = Math.round(progress);

    return (
        <div className="loading_page">
            <div className="loading_infos">
                <p className="infos">Chargement de la carte interactive...</p>
                <p className="percent">{roundedProgress}%</p>
            </div>
            <div className="progress_bar">
                <div className="progress_bar_fill" style={{ width: `${roundedProgress}%` }}></div>
            </div>
        </div>
    );
}
